<template>
  <footer class="text-dark py-4" style="background-color: #ffc600">
    <b-container>
      <!-- contact -->
      <slot></slot>
      <!-- contact -->

      <!-- contact -->
      <!-- icon -->
      <div class="d-flex align-items-center my-3">
        <hr class="flex-grow-1" />
        <p class="text-nowarp mb-0 mx-3">
          Please click the icon below to get in touch with us
        </p>
        <hr class="flex-grow-1" />
      </div>
      <div
        class="d-flex flex-column flex-md-row justify-content-center align-content-center"
      >
        <a :href="facebook" target="_blank" class="mx-3">
          <b-icon icon="facebook"></b-icon> Facebook
        </a>
        <a :href="instagram" target="_blank" class="mx-3">
          <b-icon icon="instagram"></b-icon> Instagram
        </a>
        <a :href="youtube" target="_blank" class="mx-3">
          <b-icon icon="youtube"></b-icon> Youtube Channel
        </a>
        <a :href="'tel:+852' + phone" class="mx-3">
          <i class="fas fa-phone"></i> Customer Hotline: {{ phone }}
        </a>
        <a :href="'https://wa.me/852' + whatsapp" target="_blank" class="mx-3">
          <i class="fa-brands fa-square-whatsapp"></i> WhatsApp:
          {{ whatsapp }}
        </a>
        <a :href="whatsapp_channel" target="_blank" class="mx-3">
          <b-icon icon="whatsapp"></b-icon> Forever WhatsApp Channel
        </a>
        <a :href="'mailto:' + email" target="_blank" class="mx-3">
          <i class="fa-solid fa-envelope"></i> {{ email }}
        </a>
      </div>
      <!-- icon -->
      <!-- contact -->

      <!-- 版權 -->
      <div class="text-center text- small mt-3">
        @{{ year }} FOREVER LIVING PRODUCTS ASIA LTD. All Rights Reserved.
      </div>
      <!-- 版權 -->
    </b-container>
  </footer>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      whatsapp: null,
      whatsapp_channel: null,
      facebook: null,
      instagram: null,
      youtube: null,
      wechat: null,
      email: null,
      phone: null,
    };
  },
  async created() {
    let response = await api.get("/api/get_shop_contact_info");
    for (let data of response.data) {
      console.log(data);
      switch (data.contact_type) {
        case "whatsapp":
          this.whatsapp = data.value;
          break;
        case "whatsappchannel":
          this.whatsapp_channel = data.value;
          break;
        case "facebook":
          this.facebook = data.value;
          break;
        case "instagram":
          this.instagram = data.value;
          break;
        case "youtube":
          this.youtube = data.value;
          break;
        case "wechat":
          this.wechat = data.value;
          break;
        case "email":
          this.email = data.value;
          break;
        case "phone":
          if (data.shop == "永恆生活產品亞洲有限公司 尖沙咀營運中心") {
            this.phone = data.value;
          }
      }
      console.log(this.contact_info);
    }
  },

  computed: {
    year() {
      return new Date().getFullYear();
    },
  },
  name: "footer_page_eng",
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #333;
}
a .i {
  text-decoration: none;
  color: #333;
}
.d-flex {
  flex-wrap: wrap;
  min-width: 100%;
}
</style>
